"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DestinationFilters;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _atoms = require("@whitbread-eos/atoms");
var _utils = require("@whitbread-eos/utils");
var _nextI18next = require("next-i18next");
var _react2 = require("react");
var _createCheckboxList = require("../../utils/createCheckboxList");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CLEAR_FILTERS_ENABLER = 2;
function DestinationFilters(_ref) {
  var {
    selectedFilters,
    setSelectedFilters,
    isDisabled = false,
    labels
  } = _ref;
  var [isFilterOpen, setIsFilterOpen] = (0, _react2.useState)(false);
  var {
    t
  } = (0, _nextI18next.useTranslation)();
  var ref = (0, _react2.useRef)(null);
  var {
    isLessThanSm,
    isLessThanXl
  } = (0, _utils.useScreenSize)();
  (0, _react.useOutsideClick)({
    ref: ref,
    handler: () => setIsFilterOpen(false)
  });
  var {
    filters,
    dynamicFilters
  } = labels;
  var {
    label,
    info
  } = filters;
  var baseDataTestId = 'DLP-Filters';
  (0, _react2.useEffect)(() => {
    document.body.style.overflow = isFilterOpen ? 'hidden' : 'auto';
  }, [isFilterOpen]);
  var handleFilterChange = (e, operator) => {
    var _e$target$value;
    var newState = e.target.checked ? [...selectedFilters, {
      codes: (_e$target$value = e.target.value) === null || _e$target$value === void 0 ? void 0 : _e$target$value.split(',').flat(),
      name: e.target.ariaLabel,
      operator: operator
    }] : selectedFilters.filter(selectedFilter => {
      var selectedFilterCodes = selectedFilter.codes;
      if (selectedFilterCodes.length > 1) {
        return selectedFilterCodes.join(',') !== e.target.value;
      }
      return selectedFilterCodes[0] !== e.target.value;
    });
    setSelectedFilters(newState);
  };
  var handleClearFilters = () => {
    setSelectedFilters([]);
  };
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: (0, _jsxRuntime.jsxs)(_react.Box, {
      children: [(0, _jsxRuntime.jsx)(_react.Slide, {
        direction: 'left',
        in: isFilterOpen,
        unmountOnExit: true,
        style: {
          zIndex: 999,
          background: 'rgba(0,0,0,0.5)'
        },
        children: (0, _jsxRuntime.jsxs)(_react.Box, _objectSpread(_objectSpread({}, panelStyles), {}, {
          "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'Wrapper'),
          ref: ref,
          children: [(0, _jsxRuntime.jsxs)(_react.Box, {
            pt: "2.5rem",
            position: "sticky",
            children: [(0, _jsxRuntime.jsxs)(_react.Flex, {
              justifyContent: "space-between",
              alignItems: "center",
              children: [(0, _jsxRuntime.jsx)(_react.Heading, _objectSpread(_objectSpread({
                as: "h2"
              }, headingTextStyles), {}, {
                children: label === null || label === void 0 ? void 0 : label.header
              })), (0, _jsxRuntime.jsx)(_atoms.Icon, {
                svg: (0, _jsxRuntime.jsx)(_atoms.Dismiss, {
                  "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'Close-Button')
                }),
                onClick: () => setIsFilterOpen(false),
                style: {
                  cursor: 'pointer'
                }
              })]
            }), selectedFilters.length >= CLEAR_FILTERS_ENABLER && (0, _jsxRuntime.jsx)(_react.Text, _objectSpread(_objectSpread({}, clearFiltersStyles), {}, {
              onClick: handleClearFilters,
              "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'Clear-Filters-Button'),
              children: label === null || label === void 0 ? void 0 : label.reset
            })), (0, _jsxRuntime.jsx)(_react.Divider, _objectSpread({}, dividerStyles))]
          }), (0, _jsxRuntime.jsx)(_react.Box, {
            overflow: "auto",
            height: "82vh",
            children: dynamicFilters === null || dynamicFilters === void 0 ? void 0 : dynamicFilters.map((dynamicFilterSection, i) => {
              var _dynamicFilterSection2, _info$lift;
              return (0, _jsxRuntime.jsxs)(_react.Box, {
                pt: "md",
                children: [(0, _jsxRuntime.jsx)(_react.Heading, _objectSpread(_objectSpread({
                  as: "h3",
                  mb: "sm"
                }, headingTextStyles), {}, {
                  children: dynamicFilterSection.groupTitle
                })), (0, _createCheckboxList.createCheckboxList)(baseDataTestId, selectedFilters, e => {
                  var _dynamicFilterSection;
                  return handleFilterChange(e, (_dynamicFilterSection = dynamicFilterSection.groupOperator) !== null && _dynamicFilterSection !== void 0 ? _dynamicFilterSection : '');
                }, (_dynamicFilterSection2 = dynamicFilterSection === null || dynamicFilterSection === void 0 ? void 0 : dynamicFilterSection.groupItems) !== null && _dynamicFilterSection2 !== void 0 ? _dynamicFilterSection2 : [], (_info$lift = info === null || info === void 0 ? void 0 : info.lift) !== null && _info$lift !== void 0 ? _info$lift : '', true), dynamicFilters.length - 1 !== i && (0, _jsxRuntime.jsx)(_react.Divider, _objectSpread({}, dividerStyles))]
              }, dynamicFilterSection.groupTitle);
            })
          })]
        }))
      }), (0, _jsxRuntime.jsxs)(_react.Flex, {
        alignItems: "center",
        mb: "var(--chakra-space-xmd)",
        children: [(0, _jsxRuntime.jsx)(_react.Button, _objectSpread(_objectSpread({
          "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'Open-Button'),
          size: "sm",
          variant: "genericSecondary",
          isDisabled: isDisabled,
          onClick: () => setIsFilterOpen(true)
        }, filterButtonWidth), {}, {
          children: t('dlp.filters.filtersAmount').replace('({amount})', (selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.length) > 0 ? "(".concat(selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.length, ")") : '')
        })), !isLessThanSm && isLessThanXl && selectedFilters.length > 0 && (0, _jsxRuntime.jsx)(_react.Text, _objectSpread(_objectSpread({}, clearFiltersStyles), {}, {
          mt: "0",
          mb: "0",
          ml: "0.938rem",
          onClick: () => setSelectedFilters([]),
          "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'Clear-Filters-Button'),
          children: t('tableFilter.clearAll')
        }))]
      })]
    })
  });
}
var filterButtonWidth = {
  w: {
    mobile: '8.75rem',
    xs: '10.25rem',
    sm: '7.75rem',
    lg: '11.5rem'
  }
};
var panelStyles = {
  background: 'baseWhite',
  height: '100vh',
  width: 'full',
  px: 'lg',
  maxWidth: {
    base: '19.063rem',
    xs: '19.438rem',
    sm: '21.875rem',
    md: '23.375rem',
    lg: '26.063rem',
    xl: '30.375rem'
  },
  zIndex: '9999'
};
var headingTextStyles = {
  fontSize: 'md',
  fontWeight: 'bold',
  lineHeight: '3',
  color: 'darkGrey1'
};
var dividerStyles = {
  borderColor: 'lightGrey2',
  mt: 'lg'
};
var clearFiltersStyles = {
  fontSize: 'md',
  fontWeight: 'normal',
  lineHeight: '3',
  textDecoration: 'underline',
  color: 'btnSecondaryEnabled',
  marginTop: 'md',
  marginBottom: 'lg',
  _hover: {
    cursor: 'pointer'
  }
};